import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Input, Modal, Radio, Space } from "antd";
import ReactMarkdown from "react-markdown";
import strings from "../../locale/strings.json";
import pepDefinitionMd from "../../locale/PEP_en.md";
import pepDefinitionMdDE from "../../locale/PEP_de.md";

class NatPEP extends Component {
  state = { selectedAnswer: null, explanation: null, pepDefinition: null };

  constructor(props) {
    super(props);

    const { currentLang } = props;

    fetch(currentLang === "de" ? pepDefinitionMdDE : pepDefinitionMd)
      .then((res) => res.text())
      .then((text) => {
        this.state.pepDefinition = text;
      });
  }

  validate = () => {
    const { selectedAnswer, explanation } = this.state;
    const { currentLang, setCurrentStepValid } = this.props;

    if (
      selectedAnswer &&
      selectedAnswer === strings[currentLang].nat.NONE_OF_ABOVE
    ) {
      setCurrentStepValid(true);
    } else if (selectedAnswer && explanation && explanation.length > 0) {
      setCurrentStepValid(true);
    } else {
      setCurrentStepValid(false);
    }
  };

  componentDidUpdate = () => {
    const { isActive, formData } = this.props;
    const { selectedAnswer } = this.state;

    if (isActive) {
      if (selectedAnswer == null && formData.pep != null) {
        this.setState(
          {
            selectedAnswer: formData.pep,
            explanation: formData.pepExplanation,
          },
          this.validate
        );
      }
    }
  };

  render() {
    const { selectedAnswer, pepDefinition, explanation } = this.state;
    const { currentLang } = this.props;

    return (
      <>
        <h2 style={{ marginBottom: 0, padding: 0 }}>
          {strings[currentLang].nat.STEP_PEP}
        </h2>
        <div style={{ marginBottom: "24px" }}>
          <Button
            size="small"
            type="link"
            style={{ margin: 0, padding: 0 }}
            onClick={() => {
              Modal.info({
                title: strings[currentLang].MODAL_TITLE_PEP_DEFINITION,
                content: (
                  <ReactMarkdown
                    components={{
                      p: ({ children }) => <p className="mb-2">{children}</p>,
                      ol: ({ children }) => (
                        <ol className="list-decimal pl-4">{children}</ol>
                      ),
                      ul: ({ children }) => (
                        <ul className="list-disc pl-4">{children}</ul>
                      ),
                    }}
                  >
                    {pepDefinition}
                  </ReactMarkdown>
                ),
                width: "100%",
                styles: {
                  body: {
                    maxHeight: "70vh",
                    overflowY: "scroll",
                  },
                },
                style: {
                  maxWidth: "900px",
                },
                centered: true,
              });
            }}
          >
            {strings[currentLang].WHAT_IS_A_PEP}
          </Button>
        </div>
        <Radio.Group
          value={selectedAnswer}
          onChange={(e) => {
            const { onChangeFormData } = this.props;
            this.setState({ selectedAnswer: e.target.value }, this.validate);
            onChangeFormData("pep", e.target.value);

            if (e.target.value === strings[currentLang].nat.NONE_OF_ABOVE) {
              onChangeFormData("pepExplanation", "");
            }
          }}
        >
          <Space direction="vertical">
            <Radio value={strings[currentLang].nat.CLIENT_IS_A_PEP}>
              {strings[currentLang].nat.CLIENT_IS_A_PEP}
            </Radio>
            <Radio value={strings[currentLang].nat.FAMILY_MEMBER_OF_CLIENT}>
              {strings[currentLang].nat.FAMILY_MEMBER_OF_CLIENT}
            </Radio>
            <Radio value={strings[currentLang].nat.CLOSE_ASSOCIATE_OF_CLIENT}>
              {strings[currentLang].nat.CLOSE_ASSOCIATE_OF_CLIENT}
            </Radio>
            <Radio value={strings[currentLang].nat.NONE_OF_ABOVE}>
              {strings[currentLang].nat.NONE_OF_ABOVE}
            </Radio>
          </Space>
        </Radio.Group>

        <div
          style={{ marginTop: "24px" }}
          className={
            selectedAnswer != null &&
            selectedAnswer !== strings[currentLang].nat.NONE_OF_ABOVE
              ? "fade-in"
              : "fade-out"
          }
        >
          <h3>{strings[currentLang].PLEASE_EXPLAIN}</h3>
          <Input.TextArea
            rows={4}
            placeholder={strings[currentLang].PLEASE_EXPLAIN}
            onChange={(e) => {
              const { onChangeFormData } = this.props;
              this.setState({ explanation: e.target.value }, this.validate);
              onChangeFormData("pepExplanation", e.target.value);
            }}
            value={explanation ?? ""}
          />
        </div>
      </>
    );
  }
}

NatPEP.propTypes = {
  isActive: PropTypes.bool,
  currentLang: PropTypes.any,
  setCurrentStepValid: PropTypes.func,
  onChangeFormData: PropTypes.func,
  formData: PropTypes.any,
};

export default NatPEP;
